var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShare03 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd",
  clipPath: "url(#icon_share_03_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.975 7.812a1.188 1.188 0 1 0 0 2.377 1.188 1.188 0 0 0 0-2.377M2.587 9a2.388 2.388 0 1 1 4.777 0 2.388 2.388 0 0 1-4.777 0M13.024 3.788a1.188 1.188 0 1 0 0 2.376 1.188 1.188 0 0 0 0-2.376m-2.389 1.188a2.389 2.389 0 1 1 4.777 0 2.389 2.389 0 0 1-4.777 0M13.024 11.836a1.188 1.188 0 1 0 0 2.376 1.188 1.188 0 0 0 0-2.376m-2.389 1.188a2.388 2.388 0 1 1 4.777 0 2.388 2.388 0 0 1-4.777 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.842 5.175a.6.6 0 0 1-.324.784L6.287 8.132a.6.6 0 0 1-.46-1.108l5.23-2.173a.6.6 0 0 1 .785.324M5.503 10.192a.6.6 0 0 1 .784-.324l5.231 2.173a.6.6 0 1 1-.46 1.108l-5.231-2.173a.6.6 0 0 1-.324-.784"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_share_03_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
export default SvgIconShare03;